export const DATA_TEST_ID_VIDEO = 'amp-video'
export const DATA_TEST_ID_VIDEO_WRAPPER = 'amp-video-wrapper'
export const ERROR_NO_AZURE_VIDEO_URL = 'No video url was passed!'
export const VIDEO_CONTAINER_CLASSES =
  'azuremediaplayer amp-flush-skin amp-big-play-centered'
export const WRAPPER_CLASSES = 'amsWrapper'
export const tooltipText = 'Show Transcript'
export const audioToolTipText = 'Play Video with Audio Description'
export const hideTranscript = 'Hide Transcript'
export const withoutAudioDescription = 'Play Video Without Audio Description'

export const getTranscriptToolTipText = isTranscriptActive => {
  const currentTranscriptToolTipText = isTranscriptActive
    ? hideTranscript
    : tooltipText
  return currentTranscriptToolTipText
}
export const getAudioDescToolTipText = isAudioDescActive => {
  const currentAudioDescToolTipText = isAudioDescActive
    ? withoutAudioDescription
    : audioToolTipText
  return currentAudioDescToolTipText
}
